import { Navigate } from 'react-router-dom';
import { useUserProfile } from '../../contexts/UserProfileContext';
import { useOnboardingWizardControl } from '../OnboardingWizard/OnboardingWizardProvider';
import LoadingSpinner from '../LoadingSpinner';
import { resolveDefaultAppPath } from './defaultAppPath';

/**
 * After login, sends users to their role-based home route.
 * Mandatory onboarding stays on `/` (domain root) until complete or deferred.
 */
export function DefaultRedirect() {
  const {
    isLoading,
    userType,
    canAccessDashboard,
    canAccessAccounts,
    canAccessUsers,
    canAccessContentManagement,
    canAccessCourses,
    canAccessAiRecommendation,
  } = useUserProfile();

  const { isResolvingMandatoryOnboarding, requiresRootOnboardingRoute } =
    useOnboardingWizardControl();

  if (isLoading || isResolvingMandatoryOnboarding) {
    return <LoadingSpinner />;
  }

  if (requiresRootOnboardingRoute) {
    return null;
  }

  const target = resolveDefaultAppPath(userType, {
    canAccessDashboard,
    canAccessAccounts,
    canAccessUsers,
    canAccessContentManagement,
    canAccessCourses,
    canAccessAiRecommendation,
  });

  if (target === '/unauthorized') {
    console.error('[DefaultRedirect] User has no accessible routes', { userType });
  }

  return <Navigate to={target} replace />;
}
